import { AddressTypesByCountryInterface, EInvoiceConfig } from '../Interfaces/EInvoiceInterface'
import { ReducerBuilder } from './ReducerBuilder'

const INITIAL_STATE = {
  addressTypes: {},
}

type PayloadType = AddressTypesByCountryInterface

function getAddressTypes(state: EInvoiceConfig, payload: AddressTypesByCountryInterface): EInvoiceConfig {
  return {
    ...state,
    addressTypes: payload,
  }
}

const reducer = ReducerBuilder.create<EInvoiceConfig, PayloadType>(INITIAL_STATE)
  .mapAction('GET_ADDRESS_TYPES', getAddressTypes)
  .build()

export default reducer
